import { Product, PRODUCT_CONFIG_MAP } from '@journeyapps-platform/types-accounts';

export const getProductBasedOnUrlParam = (): Product => {
  let url = new URL(window.location.toString());
  for (let key in PRODUCT_CONFIG_MAP) {
    const config = PRODUCT_CONFIG_MAP[key as Product];
    if (url.searchParams.has(config.urlParam)) {
      return key as Product;
    }
  }
  return Product.APP;
};
